/* Newsletter section — progressive enhancement only. Native form posts
   work without this file; with it: in-place success (no reload/scroll),
   loading state + double-submit guard, consent gating, aria-live
   announcements. Loaded deferred by sections/newsletter.liquid. */
(function () {
  'use strict';

  document.querySelectorAll('[data-newsletter]').forEach(function (root) {
    var form = root.querySelector('form');
    if (!form) return;
    var row = root.querySelector('[data-form-row]');
    var btn = root.querySelector('[data-submit]');
    var consent = root.querySelector('[data-consent]');
    var success = root.querySelector('[data-success]');
    var errorEl = root.querySelector('[data-error]');
    var live = root.querySelector('[data-live]');
    var serverError = root.querySelector('[role="alert"]:not([data-error])');
    var submitting = false;

    /* consent gating: button disabled until the box is ticked */
    if (consent && btn) {
      btn.disabled = !consent.checked;
      consent.addEventListener('change', function () {
        btn.disabled = !consent.checked;
      });
    }

    /* announce server-rendered errors (page reloaded without JS submit) */
    if (serverError && live) live.textContent = serverError.textContent.trim();

    if (!row || !btn || !success) return;

    form.addEventListener('submit', function (e) {
      if (submitting) {
        e.preventDefault();
        return;
      }
      if (!form.checkValidity()) return; // let native validation UI run
      e.preventDefault();
      submitting = true;

      var originalLabel = btn.textContent;
      btn.setAttribute('data-loading', '');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Sending…';

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('bad status');
          /* success: swap the form for the confirmation in place */
          row.hidden = true;
          if (consent) consent.closest('.nlx__consent').hidden = true;
          if (errorEl) errorEl.hidden = true;
          if (serverError) serverError.hidden = true;
          success.hidden = false;
          if (live) live.textContent = success.textContent.trim();
        })
        .catch(function () {
          /* network trouble — fall back to a native post so Shopify can
             render its own error state */
          submitting = false;
          btn.removeAttribute('data-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = originalLabel;
          if (errorEl) {
            errorEl.textContent = 'Something went wrong — please try again.';
            errorEl.hidden = false;
          }
        });
    });
  });
})();
